import { createSlice } from "@reduxjs/toolkit";
import {
  getNews,
  getNewsStats,
  addNews,
  updateNews,
  updateNewsStatus,
  deleteNews,
  getNewsCategories,
  addNewsCategory,
  updateNewsCategory,
  deleteNewsCategory,
} from "./thunk";

export const initialState = {
  newsList: [],
  stats: { total: 0, published: 0, draft: 0, featured: 0, scheduled: 0 },
  categories: [],
  total: 0,
  page: 1,
  hasMore: false,
  isLoading: false,
  isStatsLoading: false,
  isCatsLoading: false,
  error: null,
};

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getNews
    builder.addCase(getNews.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getNews.fulfilled, (state, action) => {
      state.isLoading = false;
      state.newsList = action.payload?.news || [];
      state.total    = action.payload?.total || 0;
      state.page     = action.payload?.page  || 1;
      state.hasMore  = action.payload?.hasMore || false;
    });
    builder.addCase(getNews.rejected, (state, action) => {
      state.isLoading = false;
      state.error = typeof action.payload === "string"
        ? action.payload
        : (action.payload?.message || action.error?.message || "Мэдээ татахад алдаа гарлаа");
    });

    // getNewsStats
    builder.addCase(getNewsStats.pending, (state) => {
      state.isStatsLoading = true;
    });
    builder.addCase(getNewsStats.fulfilled, (state, action) => {
      state.isStatsLoading = false;
      state.stats = action.payload || initialState.stats;
    });
    builder.addCase(getNewsStats.rejected, (state) => {
      state.isStatsLoading = false;
    });

    // addNews
    builder.addCase(addNews.fulfilled, (state, action) => {
      state.newsList = [action.payload, ...state.newsList];
      state.stats.total += 1;
      if (action.payload?.status === "draft") state.stats.draft += 1;
    });

    // updateNews
    builder.addCase(updateNews.fulfilled, (state, action) => {
      state.newsList = state.newsList.map((n) =>
        n._id === action.payload._id ? action.payload : n
      );
    });

    // updateNewsStatus
    builder.addCase(updateNewsStatus.fulfilled, (state, action) => {
      state.newsList = state.newsList.map((n) =>
        n._id === action.payload._id ? action.payload : n
      );
    });

    // deleteNews
    builder.addCase(deleteNews.fulfilled, (state, action) => {
      state.newsList = state.newsList.filter((n) => n._id !== action.payload.id);
      if (state.stats.total > 0) state.stats.total -= 1;
    });

    // getNewsCategories
    builder.addCase(getNewsCategories.pending, (state) => {
      state.isCatsLoading = true;
    });
    builder.addCase(getNewsCategories.fulfilled, (state, action) => {
      state.isCatsLoading = false;
      state.categories = action.payload || [];
    });
    builder.addCase(getNewsCategories.rejected, (state) => {
      state.isCatsLoading = false;
    });

    // addNewsCategory
    builder.addCase(addNewsCategory.fulfilled, (state, action) => {
      state.categories = [action.payload, ...state.categories];
    });

    // updateNewsCategory
    builder.addCase(updateNewsCategory.fulfilled, (state, action) => {
      state.categories = state.categories.map((c) =>
        c._id === action.payload._id ? action.payload : c
      );
    });

    // deleteNewsCategory
    builder.addCase(deleteNewsCategory.fulfilled, (state, action) => {
      state.categories = state.categories.filter((c) => c._id !== action.payload.id);
    });
  },
});

export default newsSlice.reducer;
